<div *ngIf="showLoader" class="spinner-container">
  <mat-spinner></mat-spinner>
</div>
